export interface UserAccountState {
  email?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  studentEmailHasAccounts?: boolean;
}

const accountsUser: UserAccountState = {
  email: undefined,
  firstName: undefined,
  lastName: undefined,
  phoneNumber: undefined,
  studentEmailHasAccounts: undefined,
};

export default accountsUser;
